import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { CreatorBadge } from "./CreatorBadge";
import { OrderSummary } from "./OrderSummary";
import { TipButton } from "./TipButton";

/**
 * Left-column gradient sidebar: back link → creator → amount →
 * order summary → tip button.
 *
 * Responsive behavior is CSS-driven: on <900px the sidebar stops
 * taking full viewport height and compacts vertically so the Pay
 * button remains visible without scrolling. The per-line order
 * summary + tip button are hidden on mobile via CSS (`.pay-order`,
 * `.pay-tip` are toggled off) — the total is still shown by the
 * big `.pay-amount` block, and the breakdown is cheap to expose
 * on a narrow screen only if the user actually needs it.
 *
 * The back link goes to `history.back()` when possible (the user
 * navigated here from somewhere else in the site) and to "/" as a
 * defensive fallback. Direct-land payers (cold URL) get "/" which
 * is the logged-out home.
 */
export function Sidebar({ link }) {
  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  };

  return (
    <aside className="pay-sidebar">
      <button className="pay-back" onClick={handleBack} aria-label="Go back">
        <FaArrowLeft size={12} /> Back
      </button>
      <CreatorBadge link={link} />
      <OrderSummary link={link} />
      <TipButton />
    </aside>
  );
}
